import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import router from "./router";
import VueMask from "v-mask";
import VueSweetalert2 from "vue-sweetalert2";
import "./helper/customFilters";
import { FormCheckboxPlugin } from "bootstrap-vue";
import { store } from "./store/store.js";
import VueQRCodeComponent from "vue-qrcode-component";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import "animate.css";
import "@egjs/vue-flicking/dist/flicking.css";
import "@egjs/flicking-plugins/dist/flicking-plugins.css";
import { translations } from "./translations.js";

// two lang plugin

// console.log(store.getters.getAppLang);
const LocalizationPlugin = {
  install(Vue) {
    Vue.prototype.$translate = function (key) {
      const currentLanguage = store.getters.getAppLang || "fa"; // Default to farsi
      return translations[currentLanguage][key] || key;
    };
  },
};

Vue.use(LocalizationPlugin);

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.component("qr-code", VueQRCodeComponent);
Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(VueResource);

Sentry.init({
  Vue,
  dsn: "https://ce195dea4614488abe292c7b4ce25316@o4504254267129856.ingest.sentry.io/4504254271717376",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [
        "rivpaynew.xyz",
        "hztpay.com",
        "rivpay55.xyz",
        /^\//,
      ],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

//API Root Address
const windowHost = window.location.host;
if (store.state.isCompName === "perfectMoney") Vue.http.options.root = "";
else if (window.location.host.includes("localhost"))
  Vue.http.options.root = "https://caspian-pay.com/api";
else Vue.http.options.root = "https://" + windowHost + "/api";
// /*API Root Address

Vue.http.options.header = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
Vue.http.interceptors.push((request, next) => {
  // Set 'x-page-referrer' to the current page's location.href
  request.headers.set("x-page-referrer", window.location.href);

  // Continue to the next interceptor or the request itself
  next();
});

Vue.use(VueSweetalert2);
Vue.use(FormCheckboxPlugin);
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
